/** Layout of the image inside an object-fit: contain box (percent of container). */
export type ContainImageRect = {
  left: number
  top: number
  width: number
  height: number
}

export function getContainImageRect(
  containerWidth: number,
  containerHeight: number,
  imageNaturalWidth: number,
  imageNaturalHeight: number,
): ContainImageRect {
  if (containerWidth <= 0 || containerHeight <= 0 || imageNaturalWidth <= 0 || imageNaturalHeight <= 0) {
    return { left: 0, top: 0, width: containerWidth, height: containerHeight }
  }
  const scale = Math.min(containerWidth / imageNaturalWidth, containerHeight / imageNaturalHeight)
  const width = imageNaturalWidth * scale
  const height = imageNaturalHeight * scale
  return {
    left: (containerWidth - width) / 2,
    top: (containerHeight - height) / 2,
    width,
    height,
  }
}

/** Map pointer position to image percentages (0–100), or null if outside the image. */
export function pointerToImagePercent(
  clientX: number,
  clientY: number,
  containerRect: DOMRect,
  imageRect: ContainImageRect,
): { x: number; y: number } | null {
  const localX = clientX - containerRect.left - imageRect.left
  const localY = clientY - containerRect.top - imageRect.top
  if (localX < 0 || localY < 0 || localX > imageRect.width || localY > imageRect.height) {
    return null
  }
  if (imageRect.width <= 0 || imageRect.height <= 0) return null
  const x = Math.round((localX / imageRect.width) * 1000) / 10
  const y = Math.round((localY / imageRect.height) * 1000) / 10
  return {
    x: Math.min(100, Math.max(0, x)),
    y: Math.min(100, Math.max(0, y)),
  }
}

/** CSS position for a pin (percent of container). */
export function imagePercentToContainerPosition(
  xPercent: number,
  yPercent: number,
  containerWidth: number,
  containerHeight: number,
  imageRect: ContainImageRect,
): { left: string; top: string } {
  const leftPx = imageRect.left + (xPercent / 100) * imageRect.width
  const topPx = imageRect.top + (yPercent / 100) * imageRect.height
  return {
    left: `${(leftPx / containerWidth) * 100}%`,
    top: `${(topPx / containerHeight) * 100}%`,
  }
}
